export default __webpack_public_path__ + "svg/CompaniesLogos/logo_google.svg?bf78a058";